import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Identity } from '../../viewmodels/login/identity';
import { OIDCProvider } from '../../viewmodels/login/oidcProvider';
import { User } from '../../viewmodels/login/user';
import { BackendService } from '../backend.service';
import { CONFIG } from '../config';
import { ConfigService } from '../config.service';
import { ApiResult } from '../messages/api-result';
import { PermissionsService } from '../permissions.service';


@Injectable()
export class AuthService {
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loggedInUser: BehaviorSubject<string> = new BehaviorSubject('');
  public ssoProviders: BehaviorSubject<OIDCProvider[]> = new BehaviorSubject<OIDCProvider[]>(null);

  private unsubscribe: Subject<boolean> = new Subject();

  constructor(
    private configService: ConfigService,
    private permissionService: PermissionsService,
    private backendService: BackendService,
  ) {
    if (this.authenticated) {
      this.loggedInUser.next(localStorage.getItem('currentUser'));
      this.loggedIn.next(true);
    } else if (this.loggedIn.getValue()) {
      this.logout();
    }
  }

  public hideSpinner() {
    this.backendService.spinner.hide();
  }

  public setCatalog(value: string) {
    this.configService.setCatalog(value);
  }

  public resetPassword(currentPassword: string, newPassword: string): Observable<User> {
    const currentUser = this.loggedInUser.getValue();

    if (!currentUser || !currentPassword || !newPassword) {
      return;
    }

    return this.backendService.resetUserPassword(currentUser, [currentPassword, newPassword]);
  }

  public passwordAlreadyResetted() {
    localStorage.setItem('already-reset', 'true');
  }

  public clearLoginSession() {
    localStorage.setItem('currentUser', '');
    localStorage.setItem('userId', '');
    localStorage.setItem('email', '');
    localStorage.setItem('catalog', '');
    localStorage.removeItem('already-reset');

    localStorage.removeItem('resetRequired');
    localStorage.removeItem('usingLoginProvider');
  }

  public logout() {
    window.location.href = window.location.origin + CONFIG.routes.authLogout;
  }

  get authenticated(): boolean {
    let isCatalog: boolean;

    if (localStorage.getItem('usercatalogs')) {
      isCatalog = true;
    }

    return isCatalog;
  }

  get userName(): string {
    return localStorage.getItem('currentUser');
  }

  get userId(): string {
    return localStorage.getItem('userId');
  }

  get email(): string {
    return localStorage.getItem('email');
  }

  get catalog(): string {
    return this.configService.selectedCatalog.getValue();
  }

  get urlCatalog(): string {
    return '/' + this.configService.selectedCatalog.getValue();
  }

  get resetPasswordRequired(): boolean {
    const required = localStorage.getItem('resetRequired');

    if (required) {
      return true;
    }

    return false;
  }

  public getSOProviders(): Observable<OIDCProvider[]> {
    return this.backendService.getAllByIdIdentity<OIDCProvider>(OIDCProvider, this.catalog, CONFIG.apiRoutes.ssoProviders);
  }

  public setpermissions() {
    this.backendService.get<Identity>(Identity).subscribe(
      (data: Identity) => {
        this.permissionService.SetPermissions(data);
      },
      (errorResult: ApiResult) => {
        if (errorResult) {
          console.log('error ' + errorResult)
        }
      },
    );
  }
}
